export default "__VITE_ASSET__BG9EBZv1__"